import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { BulkDeleteInvoicesInterface } from '../interfaces/DeleteInvoiceModalProps.interface';
import ModalComponent from '../../../../../../components/modal/modal/Modal.component';
import BulkDeleteInvoicesView from './BulkDeleteInvoices.view';

const BulkDeleteInvoicesModalComponent: FC<BulkDeleteInvoicesInterface> = ({
  invoiceIds,
  open,
  setOpen,
  reloadQuery,
  onMutate,
}) => {
  const { t } = useTranslation();
  const handleClose = () => setOpen(false);

  return (
    <ModalComponent
      title={t('invoices.bulkDeleteInvoices.title')}
      open={open}
      handleClose={handleClose}
      variant="warning"
      content={
        invoiceIds && (
          <BulkDeleteInvoicesView
            invoiceIds={invoiceIds}
            close={handleClose}
            reloadQuery={reloadQuery}
            onMutate={onMutate}
          />
        )
      }
    />
  );
};

export default BulkDeleteInvoicesModalComponent;
